import req from './request'

const DEFAULT_ENDPOINTS = {
    templatesReference: '/dashboard/employment-contracts/reference',
    templates: '/dashboard/employment-contracts',

    driverReference: '/drivers/employment-contracts/reference',
    driverContracts: '/drivers/employment-contracts',
    preview: '/drivers/employment-contracts/preview',
    generate: '/drivers/employment-contracts/generate',
    getFile: '/drivers/employment-contracts/get-file',
    signEnterprise: '/drivers/employment-contracts/sign-enterprise',
    signDriver: '/drivers/employment-contracts/sign-driver',
    downloadDocument: '/drivers/employment-contracts/download-document',
}

export default {
    templatesReference(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.templatesReference, param)
    },
    templates(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.templates, param)
    },

    driverReference(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.driverReference, param)
    },
    driverContracts(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.driverContracts, param)
    },
    preview(payload, param, method) {
        return req[method || 'post'](payload, DEFAULT_ENDPOINTS.preview, param)
    },
    generate(payload, param, method) {
        return req[method || 'post'](payload, DEFAULT_ENDPOINTS.generate, param)
    },
    getFile(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.getFile, param)
    },
    signEnterprise(payload, param, method) {
        return req[method || 'post'](payload, DEFAULT_ENDPOINTS.signEnterprise, param)
    },
    signDriver(payload, param, method) {
        return req[method || 'post'](payload, DEFAULT_ENDPOINTS.signDriver, param)
    },
    downloadDocument(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.downloadDocument, param)
    },
}